module.exports = __webpack_public_path__ + "static/media/status.37a3799d.png";